import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Step,
  StepLabel,
  Stepper,
  Typography,
} from "@mui/material";
import PartnerLeadStatusChip from "./PartnerLeadStatusChip";
import { formatPartnerLeadMobile } from "../utils/portalHelpers";

const Field = ({ label, value }) => (
  <>
    <Typography variant="caption" color="text.secondary">
      {label}
    </Typography>
    <Typography variant="body2" sx={{ mb: 1.5 }}>
      {value ?? "—"}
    </Typography>
  </>
);

const formatDate = (value) =>
  value ? new Date(value).toLocaleDateString("fa-IR") : "—";

const PartnerLeadDetailDialog = ({ open, onClose, lead, loading, isLevel1 = false }) => {
  const timeline = Array.isArray(lead?.timeline) ? lead.timeline : [];

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>جزئیات لید</DialogTitle>
      <DialogContent>
        {loading ? (
          <Typography color="text.secondary">در حال بارگذاری...</Typography>
        ) : lead ? (
          <>
            <Field label="کد لید" value={lead.leadCode} />
            <Field
              label="شماره پیگیری"
              value={lead.referenceId ?? lead.ReferenceId ?? "—"}
            />
            <Field
              label="موبایل"
              value={formatPartnerLeadMobile(lead, isLevel1)}
            />
            <Field
              label="شهر / استان"
              value={
                lead.cityName && lead.provinceName
                  ? `${lead.cityName} / ${lead.provinceName}`
                  : lead.cityName || lead.provinceName
              }
            />
            <Field label="نماینده معرف" value={lead.sourcePartnerDisplayName} />
            {isLevel1 && lead.referralLink ? (
              <Field label="لینک معرفی" value={lead.referralLink} />
            ) : null}
            {isLevel1 && lead.landingUrl ? (
              <Field label="آدرس ورود" value={lead.landingUrl} />
            ) : null}
            <Field label="تاریخ ثبت‌نام" value={formatDate(lead.registeredAt)} />
            <Field
              label="تاریخ ثبت درخواست نیروگاه"
              value={formatDate(lead.projectRequestedAt)}
            />
            <Box sx={{ mb: 1.5 }}>
              <Typography variant="caption" color="text.secondary">
                آخرین وضعیت پروژه
              </Typography>
              <Box sx={{ mt: 0.5 }}>
                <PartnerLeadStatusChip
                  label={lead.projectStatus}
                  statusKey={lead.projectStatusKey}
                />
              </Box>
            </Box>
            <Box sx={{ mb: 1.5 }}>
              <Typography variant="caption" color="text.secondary">
                وضعیت مهرسان
              </Typography>
              <Box sx={{ mt: 0.5 }}>
                <PartnerLeadStatusChip
                  label={lead.mehrsanStatus}
                  statusKey={lead.mehrsanStatusKey}
                />
              </Box>
            </Box>
            <Box sx={{ mb: 1.5 }}>
              <Typography variant="caption" color="text.secondary">
                وضعیت وام
              </Typography>
              <Box sx={{ mt: 0.5 }}>
                <PartnerLeadStatusChip
                  label={lead.loanStatus}
                  statusKey={lead.loanStatusKey}
                />
              </Box>
            </Box>
            <Box sx={{ mb: 1.5 }}>
              <Typography variant="caption" color="text.secondary">
                وضعیت پورسانت
              </Typography>
              <Box sx={{ mt: 0.5 }}>
                <PartnerLeadStatusChip
                  label={lead.commissionStatus}
                  statusKey={lead.commissionStatusKey}
                />
              </Box>
            </Box>
            <Field label="آخرین بروزرسانی" value={formatDate(lead.lastUpdatedAt)} />

            {timeline.length > 0 ? (
              <Box sx={{ mt: 2 }}>
                <Typography variant="subtitle2" sx={{ mb: 1 }}>
                  مسیر پیشرفت
                </Typography>
                <Stepper activeStep={-1} orientation="vertical" nonLinear>
                  {timeline.map((step) => (
                    <Step key={step.key} completed={step.reached} active={false}>
                      <StepLabel
                        optional={
                          step.occurredAt ? (
                            <Typography variant="caption">
                              {formatDate(step.occurredAt)}
                            </Typography>
                          ) : null
                        }
                        sx={{
                          opacity: step.reached ? 1 : 0.45,
                          "& .MuiStepLabel-label": {
                            color: step.reached ? "text.primary" : "text.disabled",
                          },
                        }}
                      >
                        {step.label}
                      </StepLabel>
                    </Step>
                  ))}
                </Stepper>
              </Box>
            ) : null}
          </>
        ) : (
          <Typography color="text.secondary">اطلاعاتی یافت نشد.</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>بستن</Button>
      </DialogActions>
    </Dialog>
  );
};

export default PartnerLeadDetailDialog;
